/* caragins — 조선일보 스타일 기사 상세 페이지 */

const S = {
  section:  { fontFamily: 'Noto Sans KR, sans-serif', fontWeight: 700, color: '#DD0000', fontSize: '12px' },
  headline: { fontFamily: 'Noto Serif KR, Georgia, serif', fontWeight: 900, color: '#1A1A1A', lineHeight: 1.35, letterSpacing: '-0.02em' },
  sub:      { fontFamily: 'Noto Serif KR, Georgia, serif', fontStyle: 'italic', fontSize: '15px', color: '#555', lineHeight: 1.7 },
  body:     { fontFamily: 'Noto Serif KR, Georgia, serif', fontSize: '16px', color: '#1A1A1A', lineHeight: 1.95 },
  byline:   { fontFamily: 'IBM Plex Mono, monospace', fontSize: '11px', color: '#888' },
  caption:  { fontFamily: 'Noto Sans KR, sans-serif', fontSize: '12px', color: '#666', lineHeight: 1.6, marginTop: '8px' },
  subhead:  { fontFamily: 'Noto Serif KR, Georgia, serif', fontWeight: 700, fontSize: '18px', color: '#1A1A1A', margin: '32px 0 12px', borderLeft: '4px solid #DD0000', paddingLeft: '14px' },
};

const related = [
  { section: '정치', headline: '여야, 예산안 협상 타결 임박… 법인세 감면 놓고 막판 이견', date: '11.27' },
  { section: '경제', headline: '한국은행 총재 "금리 인하, 아직 이르다"… 시장 기대 꺾여', date: '11.27' },
  { section: '정치', headline: '여당 비대위 출범… 총선 준비 본격화, 인적 쇄신 과제', date: '11.27' },
  { section: '경제', headline: '코스피 2,600선 회복… 반도체·2차전지 주도', date: '11.27' },
];

const tags = ['예산안', '656조', '국방', '복지', '기재부', '국회', '예결위'];

export default function Article({ onBack }) {
  return (
    <div style={{ background: 'white', maxWidth: '1140px', margin: '0 auto', padding: '0 16px' }}>

      {/* 브레드크럼 */}
      <div style={{ padding: '10px 0', borderBottom: '1px solid #E5E5E5', display: 'flex', alignItems: 'center', gap: '6px' }}>
        <button onClick={onBack}
          style={{ fontFamily: 'Noto Sans KR, sans-serif', fontSize: '12px', color: '#888', background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>
          홈
        </button>
        <span style={{ color: '#CCC' }}>›</span>
        <span style={{ fontFamily: 'Noto Sans KR, sans-serif', fontSize: '12px', color: '#888' }}>정치</span>
        <span style={{ color: '#CCC' }}>›</span>
        <span style={{ fontFamily: 'Noto Sans KR, sans-serif', fontSize: '12px', color: '#555' }}>정부, 내년 예산 656조원 확정…</span>
      </div>

      <div style={{ display: 'flex', gap: '0', paddingTop: '24px' }}>

        {/* 본문 영역 */}
        <article style={{ flex: 1, minWidth: 0, paddingRight: '40px', borderRight: '1px solid #E5E5E5' }}>

          {/* 섹션 + 헤드라인 */}
          <div style={{ marginBottom: '16px' }}>
            <span style={S.section}>■ 정치</span>
            <h1 style={{ ...S.headline, fontSize: 'clamp(22px, 3.5vw, 34px)', margin: '8px 0 12px' }}>
              정부, 내년 예산 656조원 확정…<br />복지·국방 역대 최대 편성
            </h1>
            <p style={S.sub}>
              기재부, 국회 예결위와 최종 협의 완료… 이번 주 본회의 표결 예정
            </p>
          </div>

          {/* 기자 + 날짜 + 공유 */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 0', borderTop: '1px solid #E5E5E5', borderBottom: '1px solid #E5E5E5', marginBottom: '20px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <span style={{ fontFamily: 'Noto Sans KR, sans-serif', fontWeight: 700, fontSize: '13px', color: '#1A1A1A' }}>
                정치부 이현진 기자
              </span>
              <span style={S.byline}>입력 2024.11.27 오전 08:42</span>
              <span style={S.byline}>수정 2024.11.27 오전 09:10</span>
            </div>
            <div style={{ display: 'flex', gap: '6px' }}>
              {['공유', '인쇄', '스크랩', '폰트'].map(btn => (
                <button key={btn}
                  style={{ fontFamily: 'Noto Sans KR, sans-serif', fontSize: '11px', color: '#555', background: 'none', border: '1px solid #DDD', padding: '4px 10px', cursor: 'pointer' }}>
                  {btn}
                </button>
              ))}
            </div>
          </div>

          {/* 메인 사진 */}
          <div style={{ marginBottom: '24px' }}>
            <div style={{ height: '380px', background: '#1A1A1A', border: '1px solid #E5E5E5', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <span style={{ fontFamily: 'Noto Sans KR, sans-serif', fontSize: '13px', color: 'rgba(255,255,255,0.25)' }}>
                국회의사당 본회의장
              </span>
            </div>
            <p style={S.caption}>
              ▲ 국회의사당 본회의장 전경. 정부의 656조원 규모 내년도 예산안이 이번 주 본회의에서 표결될 예정이다. /caragins DB
            </p>
          </div>

          {/* 본문 1 */}
          <div style={{ ...S.body, marginBottom: '20px' }}>
            <p style={{ marginBottom: '18px' }}>
              정부가 656조6000억원 규모의 내년도 예산안을 국회에 제출했다. 기획재정부는 27일 국회 예산결산특별위원회와 최종 협의를 마무리하고 이번 주 본회의 표결을 목표로 막바지 협상을 진행 중이라고 밝혔다. 복지·국방 분야 예산이 역대 최대 규모로 편성됐다.
            </p>
            <p style={{ marginBottom: '18px' }}>
              기재부에 따르면 이번 예산안의 총 규모는 전년 대비 3.2% 증가한 수치로, 저출생 대응과 국방력 강화에 방점이 찍혔다. 보건·복지·고용 분야는 246조5000억원으로 전체의 37.5%를 차지하며 역대 최고 비중을 기록했다.
            </p>
          </div>

          {/* 소제목 1 */}
          <h2 style={S.subhead}>복지 예산, 사상 첫 246조원 돌파</h2>
          <div style={S.body}>
            <p style={{ marginBottom: '18px' }}>
              복지 예산은 전년 대비 6.1% 늘어난 246조5000억원으로 확정됐다. 저출생 대응 예산만 5조4000억원으로, 신생아 지원금 확대와 육아휴직 급여 인상이 주요 내용이다. 기저귀·분유비 지원 대상도 기존 연소득 7000만원 이하에서 1억원 이하 가구로 확대된다.
            </p>
            <p style={{ marginBottom: '18px' }}>
              노인 기초연금은 월 33만원에서 40만원으로 단계적으로 인상된다. 의료급여 수급자 본인부담금 경감 조치도 예산에 포함됐다. 기재부 관계자는 "고령화와 저출생 문제를 동시에 해결하기 위한 재정 투자를 대폭 강화했다"고 설명했다.
            </p>
          </div>

          {/* 인용 박스 */}
          <blockquote style={{ borderLeft: '4px solid #DD0000', margin: '28px 0', padding: '16px 20px', background: '#F9F9F9' }}>
            <p style={{ fontFamily: 'Noto Serif KR, serif', fontStyle: 'italic', fontSize: '16px', color: '#333', lineHeight: 1.8, margin: 0 }}>
              "복지와 안보를 동시에 강화하는 균형 예산을 편성했다. 경기 침체 우려에도 재정 건전성을 훼손하지 않는 선에서 최대한 지원을 늘렸다."
            </p>
            <cite style={{ fontFamily: 'Noto Sans KR, sans-serif', fontSize: '12px', color: '#888', marginTop: '10px', display: 'block' }}>
              — 기획재정부 최상목 장관
            </cite>
          </blockquote>

          {/* 소제목 2 */}
          <h2 style={S.subhead}>국방비, 60조원 첫 돌파… 첨단 무기 도입 가속</h2>
          <div style={S.body}>
            <p style={{ marginBottom: '18px' }}>
              국방 예산은 전년 대비 4.5% 증액된 60조2000억원으로, 사상 처음으로 60조원 선을 넘어섰다. 한국형 전투기(KF-21) 양산 착수, 장거리 지대공 미사일(L-SAM) 추가 도입, 사이버·드론 전력 강화에 예산이 집중됐다.
            </p>
            <p style={{ marginBottom: '18px' }}>
              군 장병 급여도 병장 기준 월 125만원에서 150만원으로 인상된다. 방산 수출 지원 예산도 1500억원으로 전년 대비 두 배 이상 확대됐다.
            </p>
          </div>

          {/* 중간 사진 */}
          <div style={{ margin: '28px 0' }}>
            <div style={{ height: '240px', background: '#2D2D2D', border: '1px solid #E5E5E5', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <span style={{ fontFamily: 'Noto Sans KR, sans-serif', fontSize: '12px', color: 'rgba(255,255,255,0.2)' }}>기재부 예산안 브리핑</span>
            </div>
            <p style={S.caption}>▲ 기획재정부 최상목 장관이 27일 정부서울청사에서 내년도 예산안 편성 결과를 발표하고 있다. /연합뉴스</p>
          </div>

          {/* 소제목 3 */}
          <h2 style={S.subhead}>여야 막판 협상… 법인세·R&amp;D 예산 쟁점</h2>
          <div style={S.body}>
            <p style={{ marginBottom: '18px' }}>
              국회 처리 과정에서는 법인세 감면 연장과 R&amp;D(연구개발) 예산 삭감 문제가 핵심 쟁점으로 부상하고 있다. 여당은 기업 투자 활성화를 위해 법인세 추가 인하를 주장하는 반면, 야당은 복지 예산 증액을 맞교환 요구로 내세우고 있다.
            </p>
            <p style={{ marginBottom: '18px' }}>
              R&amp;D 예산은 정부안 기준 30조1000억원으로 전년보다 소폭 증가했으나, 야당은 20조원 이상 추가 증액을 요구하고 있어 협상 타결 여부가 불투명한 상황이다. 법정 처리 시한인 12월 2일까지 여야 합의가 이루어지지 않을 경우 정부 원안이 자동 부의될 수 있다.
            </p>
          </div>

          {/* 태그 */}
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', margin: '28px 0', paddingTop: '20px', borderTop: '1px solid #E5E5E5' }}>
            {tags.map(tag => (
              <a key={tag} href="/#"
                style={{ fontFamily: 'Noto Sans KR, sans-serif', fontSize: '12px', color: '#555', border: '1px solid #DDD', padding: '4px 12px', textDecoration: 'none', background: '#F7F7F7' }}>
                #{tag}
              </a>
            ))}
          </div>

          {/* 기자 정보 */}
          <div style={{ border: '1px solid #E5E5E5', padding: '16px', marginBottom: '28px', display: 'flex', gap: '14px', alignItems: 'center' }}>
            <div style={{ width: '52px', height: '52px', background: '#E0E0E0', borderRadius: '50%', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <span style={{ fontSize: '20px' }}>👤</span>
            </div>
            <div>
              <p style={{ fontFamily: 'Noto Sans KR, sans-serif', fontWeight: 700, fontSize: '14px', color: '#1A1A1A', marginBottom: '3px' }}>이현진 기자</p>
              <p style={{ fontFamily: 'Noto Sans KR, sans-serif', fontSize: '12px', color: '#888' }}>정치부 · 국회·예산 담당</p>
              <p style={{ fontFamily: 'IBM Plex Mono, monospace', fontSize: '11px', color: '#888', marginTop: '3px' }}>hyeonjin@caragins.com</p>
            </div>
            <a href="/#" style={{ marginLeft: 'auto', fontFamily: 'Noto Sans KR, sans-serif', fontSize: '12px', color: '#555', border: '1px solid #DDD', padding: '6px 14px', textDecoration: 'none', flexShrink: 0 }}>
              기자 구독
            </a>
          </div>

          {/* 댓글 */}
          <div style={{ borderTop: '2px solid #1A1A1A', paddingTop: '16px', marginBottom: '32px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '14px' }}>
              <h3 style={{ fontFamily: 'Noto Sans KR, sans-serif', fontWeight: 700, fontSize: '14px', color: '#1A1A1A' }}>댓글</h3>
              <span style={{ fontFamily: 'IBM Plex Mono, monospace', fontSize: '13px', color: '#DD0000', fontWeight: 700 }}>247</span>
            </div>
            <div style={{ background: '#F7F7F7', border: '1px solid #E5E5E5', padding: '12px', marginBottom: '12px' }}>
              <textarea
                placeholder="댓글을 입력하세요. (로그인 필요)"
                style={{ width: '100%', border: 'none', background: 'transparent', fontFamily: 'Noto Sans KR, sans-serif', fontSize: '13px', color: '#333', resize: 'none', outline: 'none', boxSizing: 'border-box' }}
                rows={3}
                readOnly
              />
              <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '6px' }}>
                <button style={{ background: '#1A1A1A', color: 'white', fontFamily: 'Noto Sans KR, sans-serif', fontWeight: 700, fontSize: '12px', padding: '6px 16px', border: 'none', cursor: 'pointer' }}>
                  등록
                </button>
              </div>
            </div>
            {[
              { user: '독자A',    time: '11.27 09:15', content: '예산이 이렇게 늘어나는데 재정적자는 어떻게 감당하려는 건지…', likes: 142 },
              { user: '정치팬',   time: '11.27 09:02', content: '복지 예산 확대는 좋지만 구체적인 집행 계획도 같이 공개해야 한다고 봅니다.', likes: 87 },
              { user: '경제생각', time: '11.27 08:55', content: '국방비가 처음으로 60조를 넘었군요. 요즘 안보 상황 보면 어쩔 수 없는 것 같기도 하고.', likes: 63 },
            ].map((c, i) => (
              <div key={i} style={{ padding: '12px 0', borderBottom: '1px solid #F0F0F0' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
                  <span style={{ fontFamily: 'Noto Sans KR, sans-serif', fontWeight: 700, fontSize: '12px', color: '#1A1A1A' }}>{c.user}</span>
                  <span style={{ fontFamily: 'IBM Plex Mono, monospace', fontSize: '10px', color: '#AAA' }}>{c.time}</span>
                </div>
                <p style={{ fontFamily: 'Noto Sans KR, sans-serif', fontSize: '13px', color: '#333', lineHeight: 1.6, marginBottom: '6px' }}>{c.content}</p>
                <div style={{ display: 'flex', gap: '12px' }}>
                  <button style={{ fontFamily: 'Noto Sans KR, sans-serif', fontSize: '11px', color: '#888', background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>
                    👍 {c.likes}
                  </button>
                  <button style={{ fontFamily: 'Noto Sans KR, sans-serif', fontSize: '11px', color: '#888', background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>
                    답글
                  </button>
                </div>
              </div>
            ))}
          </div>
        </article>

        {/* 우측 사이드바 */}
        <aside style={{ width: '268px', flexShrink: 0, paddingLeft: '20px' }}>

          {/* 관련 기사 */}
          <div style={{ marginBottom: '20px' }}>
            <div style={{ borderTop: '2px solid #1A1A1A', padding: '8px 0 6px', marginBottom: '8px' }}>
              <h3 style={{ fontFamily: 'Noto Sans KR, sans-serif', fontWeight: 700, fontSize: '13px', color: '#1A1A1A' }}>관련 기사</h3>
            </div>
            {related.map((a, i) => (
              <div key={i} style={{ padding: '10px 0', borderBottom: '1px solid #F0F0F0', cursor: 'pointer' }}>
                <span style={{ fontFamily: 'Noto Sans KR, sans-serif', fontWeight: 700, fontSize: '10px', color: '#DD0000' }}>■ {a.section}</span>
                <p style={{ fontFamily: 'Noto Serif KR, serif', fontWeight: 700, fontSize: '13px', color: '#1A1A1A', lineHeight: 1.5, margin: '4px 0 3px' }}>{a.headline}</p>
                <span style={{ fontFamily: 'IBM Plex Mono, monospace', fontSize: '10px', color: '#AAA' }}>{a.date}</span>
              </div>
            ))}
          </div>

          {/* canicaticare 광고 */}
          <div style={{ background: '#1A1A1A', padding: '16px', textAlign: 'center', marginBottom: '20px' }}>
            <p style={{ fontFamily: 'IBM Plex Mono, monospace', fontSize: '9px', color: 'rgba(255,255,255,0.3)', letterSpacing: '0.2em', marginBottom: '8px' }}>
              CANICATICARE
            </p>
            <p style={{ fontFamily: 'Noto Serif KR, serif', fontWeight: 900, fontSize: '18px', color: 'white', marginBottom: '6px' }}>동물병원<br />24시간 진료</p>
            <p style={{ fontFamily: 'Noto Sans KR, sans-serif', fontSize: '11px', color: 'rgba(255,255,255,0.55)', marginBottom: '12px', lineHeight: 1.6 }}>
              서울 강남 · 홍대 · 분당<br />응급 · 내과 · 외과 · 피부과
            </p>
            <a href="/#" style={{ display: 'block', background: '#DD0000', color: 'white', fontFamily: 'Noto Sans KR, sans-serif', fontWeight: 700, fontSize: '12px', padding: '8px 0', textDecoration: 'none' }}>
              지금 예약하기 →
            </a>
          </div>

          {/* 많이 본 기사 */}
          <div>
            <div style={{ borderTop: '2px solid #1A1A1A', padding: '8px 0 6px', marginBottom: '8px' }}>
              <h3 style={{ fontFamily: 'Noto Sans KR, sans-serif', fontWeight: 700, fontSize: '13px', color: '#1A1A1A' }}>많이 본 기사</h3>
            </div>
            {[
              '손흥민, EPL 통산 150호 골 달성… 아시아 선수 역사 새로 써',
              '서울 아파트값 5주째 오름세… 강남·마용성 중심 회복',
              'BTS 진, 제대 후 첫 공식 활동 시작… 팬들 열광',
              '오픈AI, 한국 사무소 개설… 서울에 아시아 거점',
              '의대 증원 갈등 1년… 의사단체, 총파업 여부 내주 결정',
            ].map((h, i) => (
              <div key={i} style={{ display: 'flex', gap: '8px', padding: '8px 0', borderBottom: '1px solid #F0F0F0', cursor: 'pointer' }}>
                <span style={{ fontFamily: 'Noto Serif KR, serif', fontWeight: 900, fontSize: '16px', color: i < 3 ? '#DD0000' : '#BBB', minWidth: '18px', lineHeight: 1.2 }}>
                  {i + 1}
                </span>
                <p style={{ fontFamily: 'Noto Sans KR, sans-serif', fontSize: '12px', color: '#1A1A1A', lineHeight: 1.5 }}>{h}</p>
              </div>
            ))}
          </div>
        </aside>
      </div>
    </div>
  );
}
